import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allBloquesPedagogicosAction,
  setActivoBloquesPedagogicosAction,
} from './BloquesPedagogicosAction';
import { PARAMS_BLOQUES_PEDAGOGICOS } from './BloquesPedagogicosReducer';
import FormBloquesPedagogicos from './components/FormBloquesPedagogicos';
import ListadoBloquesPedagogicos from './components/ListadoBloquesPedagogicos';

const BloquesPedagogicosView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {bloquesPedagogicosStore.all.length !==
          entidadesStore.ajustes.bloquesPedagogicos && (
          <BotonComponent
            click={async () => {
              await setActivoBloquesPedagogicosAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            mr={2}
            addIcon
          />
        )}
        <BotonComponent
          click={async () => {
            await setActivoBloquesPedagogicosAction(dispatch, null);
            const payload = {
              ...bloquesPedagogicosStore.params,
              idEntidad: entidadesStore.activo.id,
            };
            dispatch({
              type: PARAMS_BLOQUES_PEDAGOGICOS,
              payload,
            });
            await allBloquesPedagogicosAction(dispatch, payload);
          }}
          disabled={
            bloquesPedagogicosStore.loadingAll ||
            bloquesPedagogicosStore.all.length === 0
          }
          white
          refreshIcon
          text={
            bloquesPedagogicosStore.loadingAll
              ? 'Actualizando...'
              : 'Actualizar'
          }
        />
      </Grid>
      <Grid item md={12}>
        <ListadoBloquesPedagogicos
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <ModalComponent
        id="modalFormBloquesPedagogicos"
        title={`${
          bloquesPedagogicosStore.activo
            ? `Editar ${bloquesPedagogicosStore.activo.nombre}`
            : 'Nueva bloque pedagógico'
        }`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormBloquesPedagogicos
          activo={bloquesPedagogicosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default BloquesPedagogicosView;
